import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';

function AziziVeniceRetail({
    language
}) {
    const color = "orange";

    const images = [
        "/assets/images/projects/azizi-venice/1.webp",
        "/assets/images/projects/azizi-venice/2.webp",
        "/assets/images/projects/azizi-venice/3.webp",
        "/assets/images/projects/azizi-venice/4.webp"
    ];

    const poster = "/assets/images/projects/azizi-venice/retail-2.jpg";
    // const webm = "/assets/images/projects/azizi-venice/hero.webm";
    const video = "/assets/images/projects/azizi-venice/venice-retail.mp4";

    const {
        langs,
        langCode,
        userInfo,
        HIKALRE_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold leading-relaxed">
                        {/* <span className="text-orange-300 neon-orange">
                            الوحدات محدودة ..
                        </span> */}
                        امتلك محلك التجاري في دبي بموقع استراتيجي يخدم أكثر من 30 ألف وحدة سكنية
                        <br />
                        بدفعة أولى 299 ألف درهم فقط
                        <br />
                        <span className="text-orange-200 neon-orange">
                            عرض ليوم واحد فقط | 20 أغسطس 2026 | ادفع 20% فقط والباقى عند الاستلام
                        </span>
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl leading-relaxed">
                        Own your commercial unit in Dubai, strategically located to serve a community of 30,000+ residential units.
                        <br />
                        Starting with just AED 299,000 down payment
                        <br />
                        <span className="text-orange-200 neon-orange">
                            One-Day-Only Offer | 20 August 2026 | Pay just 20% today, with the remaining 80% upon handover
                        </span>
                    </h1>
                )}

            </>
        );
    }

    const gridDetails = [
        {
            "topic": "أنواع الوحدات",
            "text": "استوديو 3,2,1 غرفة",
        },
        {
            "topic": "الأسعار تبدأ من",
            "text": isUAE ? "655,000 درهم" : "180 ألف دولار",
        },
        {
            "topic": "أقساط شهرية",
            "text": isUAE ? "6600 درهم" : "1800 دولار",
        },
    ];

    const imageDetails = {
        "title": "✨ عرض حصري لفترة محدودة ✨",
        "desc": "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية من ماركة Siemens الألمانية"
    };

    return (
        <>
            <ColorLandingPage
                color={color}
                // language={language}
                langToggle={{
                    en: "/azizi/venice/retail",
                    ar: "/azizi/venice/retail/ar",
                }}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                // gridDetails={gridDetails}
                // imageDetails={imageDetails}
                displayAmenity={false}
                displayVisa={false}
                base_url={HIKALRE_URL}
                developer="Azizi"
                project="Venice"
                projectName={"Venice"}
                leadType="Commercial"
                language={language === "ar" ? "Arabic" : "English"}
                enquiries={["Retail"]}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={101}
            />
        </>
    );
}

export default AziziVeniceRetail;
